module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Thea Cooper, Arthur Ainsberg\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("THEA COOPER is an author, playwright, editor and teacher. ARTHUR AINSBERG is an author and financial industry veteran whose successful battle with Hodgkin's disease sparked his interest in medical history.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nJ1CSm/tc-custom/9781429965699.jpg?1722312427884",
      "alt": "This image is the cover for the book Breakthrough"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Breakthrough\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("It is 1919 and Elizabeth Hughes, the eleven-year-old daughter of America's most-distinguished jurist and politician, Charles Evans Hughes, has been diagnosed with juvenile diabetes. It is essentially a death sentence. The only accepted form of treatment – starvation – whittles her down to forty-five pounds skin and bones. Miles away, Canadian researchers Frederick Banting and Charles Best manage to identify and purify insulin from animal pancreases – a miracle soon marred by scientific jealousy, intense business competition and fistfights. In a race against time and a ravaging disease, Elizabeth becomes one of the first diabetics to receive insulin injections – all while its discoverers and a little known pharmaceutical company struggle to make it available to the rest of the world. "), _c('br'), _c('br'), _vm._v("Relive the heartwarming true story of the discovery of insulin as it's never been told before. Written with authentic detail and suspense, and featuring walk-ons by William Howard Taft, Woodrow Wilson, and Eli Lilly himself, among many others.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0